export const ChallengeIcon = ({ className }) => (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <rect width="24" height="24"/>
    <path d="M3 18H8V21H3V18Z" stroke="#050505" strokeWidth="1.5" strokeLinejoin="round"/>
    <rect x="8" y="15" width="6" height="6" stroke="#050505" strokeWidth="1.5" strokeLinejoin="round"/>
    <rect x="14" y="12" width="7" height="9" stroke="#050505" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M17.75 3C17.75 2.58579 17.4142 2.25 17 2.25C16.5858 2.25 16.25 2.58579 16.25 3L17.75 3ZM17.75 12L17.75 3L16.25 3L16.25 12L17.75 12Z" fill="black"/>
    <path d="M17 3L11.5 6.5L17 9" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>);
